// extracted by mini-css-extract-plugin
export default {"wrap":"Er-z","fullWidth":"Fr-z","items":"Gr-z","featureCss":"Hr-z","disabled":"Ir-z","imgCss":"Jr-z"};